import { localImages } from './localImages';

export const GenderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Other", value: "Other" },
];

export const MaritalStatusOptions = [
  { label: "Single", value: "Single" },
  { label: "Married", value: "Married" },
  { label: "Divorced", value: "Divorced" },
  { label: "Widowed", value: "Widowed" },
];

export const bookingDetails = [
  {
    bookingId: "#Z99335T",
    bookingDate: "30 july 2021, 10:00 AM",
    bookingName: "Booking Name",
    Trip: "Trip Name",
    bookingStatus: "ongoing",
    clientName: "Preveen Elumalai",
    tripType: "Export",
    point: "Clearance",
    type: "point",
    tripStatus: "Ongoing",
    totalTrips: 5,
  },
  {
    bookingId: "#Z99335T",
    bookingDate: "30 july 2021, 10:00 AM",
    bookingName: "Booking Name",
    Trip: "Trip Name",
    bookingStatus: "Unassigned",
    clientName: "Preveen Elumalai",
    tripType: "Export",
    point: " Clearance",
    type: "point",
    tripStatus: "Ongoing",
    totalTrips: 123,
  },
];
export const TripDetails = [
  {
    bookingId: "Empty to Warehouse",
    bookingDate: "30 july 2021, 10:00 AM",
    bookingName: "Booking Name",
    Trip: "Chennai Manali - Ennore",
    bookingStatus: "ongoing",
    clientName: "Land (Road)",
    tripType: "Export",
    point: "Clearance",
    type: "point",
    tripStatus: "Ongoing",
    totalTrips: 5,
  },
  {
    bookingId: "Warehouse to Port",
    bookingDate: "30 july 2021, 10:00 AM",
    bookingName: "Booking Name",
    Trip: "TN 73A 0603",
    bookingStatus: "Completed",
    clientName: "Sea Mode",
    tripType: "Export",
    point: " Clearance",
    type: "point",
    tripStatus: "Ongoing",
    totalTrips: 123,
  },
];
export const Documents = [
  {
    bookingId: "Trip Name",
    bookingDate: "No of Files 25",
    bookingName: "Booking Name",
    Trip: "Booking Documents",

  },
  {
    bookingId: "Trip Name",
    bookingDate: "No of Files 25",
    bookingName: "Booking Name",
    Trip: "cargo Documents",

  },
];
export const Expenses = [
  {
    bookingId: "Trip Name",
    bookingDate: "No of Files 25",
    bookingName: "Booking Name",
    Trip: "Fuel Expenses",

  },
  {
    bookingId: "Trip Name",
    bookingDate: "No of Files 25",
    bookingName: "Booking Name",
    Trip: "Toll Expenses",

  },
  {
    bookingId: "Trip Name",
    bookingDate: "No of Transactions  25",
    bookingName: "Booking Name",
    Trip: "RTO Expenses",

  },
  {
    bookingId: "Trip Name",
    bookingDate: "No of Transactions  25",
    bookingName: "Booking Name",
    Trip: "CHA Expenses",

  },
  {
    bookingId: "Trip Name",
    bookingDate: "No of Transactions  25",
    bookingName: "Booking Name",
    Trip: "Liner Expenses",

  },
  {
    bookingId: "Trip Name",
    bookingDate: "No of Transactions  25",
    bookingName: "Booking Name",
    Trip: "Transporter Expenses",

  },
  {
    bookingId: "Trip Name",
    bookingDate: "No of Transactions  25",
    bookingName: "Booking Name",
    Trip: "Govt/Legal Expenses",

  },
  {
    bookingId: "Total Expenses",
    bookingDate: "No of Transactions 125",
    bookingName: "Booking Name",
    Trip: "Total Expenses",

  },
];
export const FuelExpenses = [
  {
    bookingId: "Person Name: Z99335T",
    bookingDate: "",
    bookingName: "Booking Name",
    Trip: "Fuel Expense Name",
    tripStatus: "Verified",
    images: [
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
    ],

  },
  {
    bookingId: "Person Name: Z99335T",
    bookingName: "Booking Name",
    Trip: "Fuel Expense Name",
    tripStatus: "Verified",
    images: [
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
    ],

  },
  {
    bookingId: "Person Name: Z99335T",
    bookingName: "Booking Name",
    Trip: "Fuel Expense Name",
    tripStatus: "Verified",
    images: [
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
    ],
  },
  {
    bookingId: "Person Name: Z99335T",
    bookingName: "Booking Name",
    Trip: "Fuel Expense Name",
    tripStatus: "Verified",
    images: [
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
    ],

  },
];
export const tripDetails = [
  {
    tripId: "#Z99335T",
    tripDate: "30 july 2021, 10:00 AM",
    tripName: "Trip Name",
    tripStatus: "ongoing",
    clientName: "Preveen Elumalai",
    tripType: "Export",
    totalTrips: 5,
  },
  {
    tripId: "#Z99335T",
    tripDate: "30 july 2021, 10:00 AM",
    tripName: "Trip Name",
    tripStatus: "ongoing",
    clientName: "Preveen Elumalai",
    tripType: "Export",
    totalTrips: 123,
  },
];
export const bookingStatus = [
  {
    count: "00",
    lable: "Total Bookings",
    backgroundColor: "#6991FF",
    textColor: "white",
  },
  {
    count: "00",
    lable: "Unassigned ",
    backgroundColor: "#FF9788",
    textColor: "white",
  },
  {
    count: "00",
    lable: "ongoing",
    backgroundColor: "#73DC9D",
    textColor: "white",
  },
  {
    count: "00",
    lable: "Cancelled",
    backgroundColor: "#FFB470",
    textColor: "white",
  },
  {
    count: "00",
    lable: "Completed",
    backgroundColor: "#73DC9D",
    textColor: "white",
  },
];
export const bookingTabs = [
  "All Bookings",
  "Draft",
  "Pending",
  "On Going",
  "Holds",
  "Clearance Points",
  "Cancelled",
  "Completed",
];
export const containerDetails = [
  {
    liner: "Maersk",
    surveryor: "Preveen Elumalai",
    company: "Maersk Technologies Pvt Ltd",
    phone: "9876543210",
    location: "Chennai",
    email: "praveenfly22@gmail.com",
    containerId: "#123456778",
    containerType: "Closed, 20’ Ft",
    features: [
      "smart lock",
      "wooden floor",
      "Temperature control",
      "GPS tracking",
      "Shock sensor",
      "Door sensor",
      "Light sensor",
      "Humidity sensor",
      "Air quality sensor",
      "Fire sensor",
      "Water sensor",
      "Tamper proof",
      "Anti theft",
      "Anti break",
      "Anti cut",
      "Anti climb",
      "Anti slip",
    ],
    images: [
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
    ],
    status: "verified",
  },
  {
    liner: "Maersk",
    surveryor: "Preveen Elumalai",
    company: "Maersk Technologies Pvt Ltd",
    phone: "9876543210",
    location: "Chennai",
    email: "praveenfly22@gmail.com",
    containerId: "#123456000",
    containerType: "Closed, 20’ Ft",
    features: [
      "smart lock",
      "wooden floor",
      "Temperature control",
      "GPS tracking",
      "Shock sensor",
      "Door sensor",
      "Light sensor",
      "Humidity sensor",
      "Air quality sensor",
      "Fire sensor",
      "Water sensor",
      "Tamper proof",
      "Anti theft",
      "Anti break",
      "Anti cut",
      "Anti climb",
      "Anti slip",
    ],
    images: [
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
      "localImages.truckTrailerSunset",
    ],
    status: "verified",
  },
];

export const driverDetails = [
  {
    name: "Sanjay",
    company: "Maersk Technologies Pvt Ltd",
    phone: "9876543210",
    email: "some@gmail.com",
    status: "Available",
  },
  {
    name: "Rajesh",
    company: "Maersk Technologies Pvt Ltd",
    phone: "9876543211",
    email: "rajesh@gmail.com",
    status: "Busy",
  }
]

export const containerDetailsData = [
  {
    id: "MASK5657787885",
    task: "Empty to Warehouse",
    date: "30 July 2021, 10:00 AM",
    linerName: "Maersk",
    localStorage: "Chennai",
    weight: "20 Ton",
    status: "Ongoing",
  },
  {
    id: "CMA 8768787679799",
    task: "Warehouse to Port",
    date: "30 July 2021, 10:00 AM",
    linerName: "Maersk",
    localStorage: "Chennai",
    weight: "20 Ton",
    status: "Completed",
  },
  {
    id: "CMA 8768787679799",
    task: "Warehouse to Port",
    date: "30 July 2021, 10:00 AM",
    linerName: "Maersk",
    localStorage: "Chennai",
    weight: "20 Ton",
    status: "Completed",
  }
]
export const cargoDetailsData = [
  {
    id: "Cargo Name",
    task: "Empty to Warehouse",
    date: "30 July 2021, 10:00 AM",
    linerName: "Maersk",
    localStorage: "Chennai",
    weight: "20 Ton",
    status: "Ongoing",
  },
  {
    id: "Cargo Name",
    task: "Warehouse to Port",
    date: "30 July 2021, 10:00 AM",
    linerName: "Maersk",
    localStorage: "Chennai",
    weight: "20 Ton",
    status: "Completed",
  },
  {
    id: "Cargo Name",
    task: "Warehouse to Port",
    date: "30 July 2021, 10:00 AM",
    linerName: "Maersk",
    localStorage: "Chennai",
    weight: "20 Ton",
    status: "Completed",
  }
]

export const images = [
  "localImages.truckTrailerSunset",
  "localImages.truckTrailerSunset",
  "localImages.truckTrailerSunset",
  "localImages.truckTrailerSunset",
  "localImages.truckTrailerSunset",
]
